export const COMPANY_CREATED = 'company.created' as const;
export const CONTACT_CREATED = 'contact.created' as const;
export const CONTACT_NOTE_CREATED = 'contactNote.created' as const;
export const DEAL_CREATED = 'deal.created' as const;
export const DEAL_NOTE_CREATED = 'dealNote.created' as const;

export enum UPLOAD_FIELD_NAMES {
	image = 'image',
	layout = 'layout',
	document = 'document',
	video = 'video'
}

export enum PROPERTY_TYPES {
	Apartment = 'apartment',
	Office = 'office',
	Commerce = 'commerce'
}
